import { render, staticRenderFns } from "./ApplyGroupConfig.vue?vue&type=template&id=de28c54e"
import script from "./ApplyGroupConfig.vue?vue&type=script&lang=js"
export * from "./ApplyGroupConfig.vue?vue&type=script&lang=js"
import style0 from "./ApplyGroupConfig.vue?vue&type=style&index=0&id=de28c54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports